/**
 * Nomes reservados para arquivos de contexto anexados a uma atividade.
 *
 * Os arquivos de contexto são gravados em `tasks/<prdDirectory>/<fileName>`,
 * o mesmo diretório onde as fases do pipeline geram seus artefatos
 * (`prd.md`, `techspec.md`, `tasks.md` e `<n>_task.md`). Um upload com um
 * desses nomes sobrescreveria o artefato gerado, então o nome é bloqueado
 * tanto no frontend quanto no backend.
 */
export const RESERVED_CONTEXT_FILE_NAMES = [
  'prd.md',
  'tasks.md',
  'techspec.md',
] as const;

/** Sufixo dos arquivos de task gerados na divisão (`1_task.md`, `2_task.md`, ...). */
export const RESERVED_CONTEXT_FILE_SUFFIX = '_task.md';

/**
 * Indica se o nome de arquivo colide com um artefato gerado pelas fases.
 * Comparação case-insensitive: o clone roda em filesystems case-insensitive
 * no Windows/macOS, onde `PRD.md` colide com `prd.md`.
 */
export function isReservedContextFileName(fileName: string): boolean {
  const normalized = fileName.trim().toLowerCase();
  return (
    (RESERVED_CONTEXT_FILE_NAMES as readonly string[]).includes(normalized) ||
    normalized.endsWith(RESERVED_CONTEXT_FILE_SUFFIX)
  );
}
